export default __webpack_public_path__ + "static/media/icon-transactional.dc305417.svg";